import { useNavigate } from 'react-router-dom';
import type { Project } from '@/mocks/projects';
import { useProjectI18n } from '@/hooks/useProjectI18n';

interface ProjectCardProps {
  project: Project;
}

export default function ProjectCard({ project }: ProjectCardProps) {
  const navigate = useNavigate();
  const { t_title, t_tag, t_description, t_location, t_client } = useProjectI18n();

  return (
    <div
      onClick={() => navigate(`/projeler/${project.slug}`)}
      className="group relative overflow-hidden rounded-2xl bg-white border border-gray-100 hover:border-amber-200 transition-all duration-300 cursor-pointer"
      style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
    >
      {/* Image */}
      <div className="w-full h-60 overflow-hidden">
        <img
          src={project.image}
          alt={t_title(project)}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
        />
      </div>

      {/* Content */}
      <div className="p-5">
        <div className="flex items-center justify-between mb-3">
          <span
            className="text-amber-600 text-xs font-semibold bg-amber-50 border border-amber-100 rounded-full px-3 py-1 whitespace-nowrap"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {t_tag(project)}
          </span>
          <span
            className="text-gray-400 text-xs"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {project.year}
          </span>
        </div>
        <h3
          className="text-gray-900 font-bold text-base mb-1 group-hover:text-amber-600 transition-colors duration-300"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          {t_title(project)}
        </h3>
        <p
          className="text-gray-500 text-xs flex items-center gap-1.5 mb-3"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          <i className="ri-map-pin-line text-amber-500 text-xs" />
          {t_location(project)}
        </p>
        <p
          className="text-gray-500 text-xs leading-relaxed line-clamp-2"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          {t_description(project)}
        </p>
        <div className="mt-4 flex items-center justify-between pt-3 border-t border-gray-100">
          <span
            className="text-gray-400 text-xs flex items-center gap-1"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <i className="ri-building-line text-amber-400 text-xs" />
            {t_client(project)}
          </span>
          <div className="w-7 h-7 flex items-center justify-center bg-gray-100 group-hover:bg-amber-500 rounded-full transition-colors duration-300">
            <i className="ri-arrow-right-up-line text-gray-400 group-hover:text-white transition-colors duration-300 text-sm" />
          </div>
        </div>
      </div>
    </div>
  );
}